module.exports = __webpack_public_path__ + "img/8e153993060fb62e461272ed5807f19f.png";